<template>
  <div class="ctt" id="Contact">
    <p class="title" name="Contact">Contact Us</p>
    <div class="main">
      <h4 class="sub-title">Let's talk</h4>
      <el-form class="ctt-form" ref="contact_form" :rules="rules" label-width="80px" :model="formItem">
        <el-form-item prop="type">
          <el-select v-model="formItem.type" placeholder="I'm interested in">            
            <el-option label="Advertise" value="Advertise"></el-option>
            <el-option label="Monetize" value="Monetize"></el-option>
            <el-option label="Game" value="Game"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="from_name">
          <el-input placeholder="Full name" v-model="formItem.from_name"></el-input>
        </el-form-item>
        <el-form-item prop="from_email">
          <el-input placeholder="Email" v-model="formItem.from_email"></el-input>
        </el-form-item>
        <el-form-item prop="message">
          <el-input type="textarea" :rows="5" props="message" placeholder="Message" v-model="formItem.message"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="submitForm" type="primary">Contact Us</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import emailjs from '@emailjs/browser';
export default {
  name: "Contact",
  mounted() {
    // this.toTop();
  },
  methods: {
    toTop() {
      document.documentElement.scrollTop = 0;
    },
    submitForm() {
      this.$refs.contact_form.validate((valid) => {
        if (valid) {
          this.sendEmail();
        } else {
          return false;
        }
      });
    },
    sendEmail() {
      emailjs.init('aVCDutbo-XxJVe0Y5');
      try {
        emailjs.send("service_apvpclr", "template_9qo4jno", this.formItem);
        this.$refs.contact_form.resetFields();
        this.$message({
          message: 'message submitted successfully',
          type: 'success'
        });
      } catch (err) {
        console.error(err);
        this.$message.error('message submission failed, please try again');
      }
    }
  },
  data: function () {
    return {
      formItem: {
        type: '',
        from_name: '',
        from_email: '',
        message: ''
      },
      rules: {
        type: [
          { required: true, message: 'Please select what you are interested in', trigger: 'change' }
        ],
        from_name: [
          { required: true,  message: 'Please input your name', trigger: 'blur' },
          { type: 'string', min: 2, message: 'your name must be string'}
        ],
        from_email: [
          { required: true,  message: 'Please input your email address', trigger: 'blur'  },
          { type: 'email', message: 'Please input the correct email address', trigger: 'blur'}
        ]
      }
    }
  }
};
</script>
<style>

</style>
<style lang="scss" scoped>
.ctt {
  background: #ffffff;
  position: relative;
  box-shadow: $section-box-shadow;
  .title {
    margin-top: px2rem(100);
  }
  .main {
    padding: 0 px2rem(150);
    margin-bottom: px2rem(60);
    .sub-title {
      text-align: left;
      margin: px2rem(50) 0;
      font-weight: bolder;
      font-family: "Helvetica Neue",sans-serif;
    }
    .ctt-form {
      .el-select, .el-button {
        width: 100%;
      }
      width: px2rem(400);
    }
  }
}
</style>